<template>
  <v-autocomplete
    :items="categories"
    item-text="name"
    item-value="id"
    @change="handleSelect"
    :loading="loading"
    :value="category"
    return-object
    v-bind="$attrs"
  ></v-autocomplete>
</template>

<script>
import { mapActions } from "vuex";
import { index as indexCategories } from '@/services/categories';

export default {
  name: "category-select",
  props: {
    category: [Object, Array]
  },
  model: {
    prop: "category",
    event: "change"
  },
  data: () => ({
    loading: false,
    filter: null
  }),
  methods: {
    ...mapActions("categories", ["loadCategories"]),
    handleSelect(value) {
      this.$emit("change", value);
      this.loading = false;
    },
    async getCategories() {
      this.loading = true;
      try {
        const response = await indexCategories({ filter: this.filter, list: true, local_category: this.linked });
        this.categories = response;
      } catch (e) {
        console.log('Falha ao carregar categorias');
      } finally { 
        this.loading = false;
      }
    }
  },
  computed: {
    categories: function() {
      return this.$store.getters['categories/getCategories'];
    }
  },
  created() {
    this.loadCategories();
  }
};
</script>